import { HttpClient } from '@angular/common/http';

/**
 * @class ServiceEventApi
 * @description Events related to a service
 */
export class ServiceEventsApi {
  endpoint = '/events'
  constructor(private http: HttpClient) { }
}
